import { loadImportPreview, resumeQueuedImport, watchQueuedImport } from './importpreview';
import { ajaxPromise, confirmDialog, displayNotification, logerror, toggleSlide } from './utils';

if ($('#user_import_form').length === 1) {
    init_user_import();
}

function init_user_import() {
    let uploadResponse: any = null;
    let guid: string | null = null;
    let previewTable: DataTables.Api | null = null;

    toggleSlide($('#user_import_options_toggle'), $('#user_import_options_container'));

    $('#user_import_cancel').off('click').on('click', () => {
        if (window.history.length > 1) {
            window.history.back();
            return;
        }
        window.location.href = '/ui';
    });

    $('#user_import_options_reset').on('click', () => {
        $('#user_import_send_invites').val('0');
        $('#user_import_auto_create_groups').val('1');
    });

    $('#user_import_download_template').on('click', () => {
        window.location.href = '/data/users_template';
    });

    const showUploadForm = () => {
        $('#user_import_upload_section').show();
        $('#user_import_preview_section').hide();
        $('#user_import_commit_status').hide();
        $('#user_import_commit, #user_import_discard').prop('disabled', false);
    };

    const showPreview = () => {
        $('#user_import_upload_section').hide();
        $('#user_import_preview_section').show();
    };

    $('#user_import_test').on('click', async function () {
        const fileInput = $('#user_import_file')[0] as HTMLInputElement;
        if (!fileInput.files || !fileInput.files.length) {
            displayNotification('No File', 'Please select a file first.', 'warning');
            return;
        }

        const formData = new FormData();
        formData.append('file', fileInput.files[0]);
        formData.append('mode', '0');
        formData.append('send_invites', $('#user_import_send_invites').val() as string);
        formData.append('auto_create_groups', $('#user_import_auto_create_groups').val() as string);

        $('#user_import_spinner').show();
        $('#user_import_test').prop('disabled', true);

        try {
            const response = await ajaxPromise('/import/user_upload', formData);
            $('#user_import_spinner').hide();
            $('#user_import_test').prop('disabled', false);

            if (response.msgs) {
                uploadResponse = response;
                previewTable = loadImportPreview({
                    prefix: 'user_import',
                    uploadResponse: response,
                    existingTable: previewTable,
                    showPreview,
                });
                displayNotification('Upload Failed', 'The spreadsheet format is invalid. Please check the errors.', 'danger');
                return;
            }

            if (response.rc === 'OK') {
                guid = response.guid;
                uploadResponse = response;
                previewTable = loadImportPreview({
                    prefix: 'user_import',
                    uploadResponse: response,
                    existingTable: previewTable,
                    showPreview,
                });
                displayNotification('Upload Successful', 'Please review the changes before confirming.', 'success');
            } else {
                displayNotification('Upload Failed', response.message || response.msg || 'The import test failed. Please check your file.', 'danger');
            }
        } catch (error) {
            $('#user_import_spinner').hide();
            $('#user_import_test').prop('disabled', false);
            displayNotification('Error', 'An error occurred while processing the file.', 'danger');
            logerror('user import test', error);
        }
    });

    $('#user_import_commit').on('click', async function () {
        if (!guid) {
            displayNotification('Preview Required', 'Please run a preview first.', 'warning');
            return;
        }

        const { preview } = uploadResponse || {};
        const hasErrors = preview && preview.some((row: any) => row.errors && row.errors.length > 0);
        if (hasErrors) {
            displayNotification('Errors Present', 'Cannot confirm import with validation errors. Please fix your spreadsheet and re-upload.', 'danger');
            return;
        }

        const confirmed = await confirmDialog({
            dialogTitle: 'Confirm Import',
            bodyText: 'Are you sure you want to confirm this import? This action cannot be undone.',
            confirmText: 'Confirm Import',
            confirmStyle: 'success',
        });

        if (!confirmed) {
            return;
        }

        const formData = new FormData();
        formData.append('guid', guid);
        formData.append('mode', '1');
        formData.append('send_invites', $('#user_import_send_invites').val() as string);
        formData.append('auto_create_groups', $('#user_import_auto_create_groups').val() as string);

        $('#user_import_commit, #user_import_discard').prop('disabled', true);

        try {
            const response = await ajaxPromise('/import/user_upload', formData);
            if (!response.queued) {
                $('#user_import_commit, #user_import_discard').prop('disabled', false);
                displayNotification('Import Failed', response.message || response.msg || 'The import failed.', 'danger');
                return;
            }

            $('#user_import_commit_status_text').text('Import queued. You can leave this page. Coming back will show whether it is still running.');
            $('#user_import_commit_status').show();

            const result = await watchQueuedImport(guid);
            if (result.state === 'done') {
                displayNotification('Import Complete', 'Users have been successfully imported.', 'success');
                const formElement = $('#user_import_form')[0] as HTMLFormElement;
                formElement.reset();
                uploadResponse = null;
                guid = null;
                $('.file-text').text('Choose a file or drag it here');
                showUploadForm();
            } else if (result.state === 'waiting') {
                $('#user_import_commit_status i').removeClass('fa-spin fa-spinner').addClass('fa-clock-o');
                $('#user_import_commit_status_text').text(result.msg);
                displayNotification('Import Still Running', result.msg, 'info');
            } else {
                $('#user_import_commit_status').hide();
                $('#user_import_discard').prop('disabled', false);
                displayNotification('Import Failed', result.msg, 'danger');
            }
        } catch (error) {
            $('#user_import_commit_status').hide();
            $('#user_import_commit, #user_import_discard').prop('disabled', false);
            displayNotification('Error', 'An error occurred while committing the import.', 'danger');
            logerror('user import commit', error);
        }
    });

    $('#user_import_discard').on('click', async function () {
        const confirmed = await confirmDialog({
            dialogTitle: 'Discard Changes',
            bodyText: 'Are you sure you want to discard these changes?',
            confirmText: 'Discard',
            confirmStyle: 'warning',
        });

        if (confirmed) {
            if (guid) {
                try {
                    const response = await ajaxPromise('/import/discard', { guid });
                    if (response.rc !== 'OK') {
                        displayNotification('Discard Failed', response.msg || response.message || 'This preview could not be discarded.', 'danger');
                        return;
                    }
                } catch (error) {
                    logerror('user import discard', error);
                    displayNotification('Discard Failed', 'This preview could not be discarded.', 'danger');
                    return;
                }
            }

            const formElement = $('#user_import_form')[0] as HTMLFormElement;
            formElement.reset();
            uploadResponse = null;
            guid = null;
            $('.file-text').text('Choose a file or drag it here');
            showUploadForm();
        }
    });

    $('#user_import_file').on('change', function () {
        uploadResponse = null;
        const fileInput = this as HTMLInputElement;
        const fileLabel = $('.file-text');
        if (fileInput.files && fileInput.files.length > 0) {
            fileLabel.text(fileInput.files[0].name);
        } else {
            fileLabel.text('Choose a file or drag it here');
        }
    });

    resumeQueuedImport('user_import', 'user', 'Users have been successfully imported.');
}
